/*
 * VDC Cart Recommendations v5 — dynamic in-cart cross-sells for the Impact theme.
 * - Dynamic recs via Shopify Product Recommendations API (intent=related)
 * - Native Impact drawer integration (add via /cart/add.js with bundled sections)
 * - Server-side pink star ratings fetched per rec from the vdc-product-stars section
 * - Rebuy hard-suppressor: removes any lingering uninstalled-Rebuy Script-Tag UI
 * - v5: dropped AbortController cancellation (the renderSeq guard already discards stale
 *   renders; aborting threw uncaught AbortError noise in the console on rapid cart changes)
 */
(function () {
  'use strict';

  // --- Rebuy hard-suppressor: CSS-hide + DOM-remove (observer) + no-op API ---
  (function suppressRebuy() {
    var SEL = '.rebuy-cart,.rebuy-cart__flyout,.rebuy-smart-cart,.rebuy-modal,.rebuy-modal-backdrop,.rebuy-widget,.rebuy-ui-container,[data-rebuy-id],[data-rebuy-component],[id^="rebuy-widget"],rebuy-cart,rebuy-smart-cart';
    try {
      var s = document.createElement('style');
      s.setAttribute('data-vdc-rebuy-suppress', '');
      s.textContent = SEL + '{display:none!important;visibility:hidden!important;}';
      (document.head || document.documentElement).appendChild(s);
    } catch (e) {}
    function noop() {}
    function nuke() {
      try {
        var els = document.querySelectorAll(SEL);
        Array.prototype.forEach.call(els, function (el) { if (el && el.parentNode) el.parentNode.removeChild(el); });
      } catch (e) {}
      try {
        var R = window.Rebuy;
        if (R && R.SmartCart) {
          R.SmartCart.skip_open = true;
          R.SmartCart.show = noop;
          if (typeof R.SmartCart.hide === 'function') { try { R.SmartCart.hide(); } catch (e) {} }
        }
        if (R && R.Cart && typeof R.Cart.show === 'function') { R.Cart.show = noop; }
      } catch (e) {}
    }
    nuke();
    try { new MutationObserver(nuke).observe(document.documentElement, { childList: true, subtree: true }); } catch (e) {}
    var n = 0, t = setInterval(function () { nuke(); if (++n > 80) clearInterval(t); }, 250);
    document.addEventListener('DOMContentLoaded', nuke);
    window.addEventListener('load', nuke);
  })();

  var CONFIG = {
    intent: 'related',
    maxRecs: 3,
    fetchLimit: 12,
    cacheTTLms: 5 * 60 * 1000,
    excludeHandles: ['free-returns-package-protection', 'package-protection'],
    excludeTypes: ['Gift card'],
    container: '#vdc-cart-recs',
    starsSection: 'vdc-product-stars'
  };

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var renderSeq = 0;
  var inFlightAdds = {};

  function getJSON(url, opts) {
    return fetch(url, opts || {}).then(function (r) {
      return r.json().then(function (body) {
        if (!r.ok) { var e = new Error('HTTP ' + r.status); e.body = body; throw e; }
        return body;
      });
    });
  }
  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') return window.Shopify.formatMoney(cents);
    return '$' + (Number(cents || 0) / 100).toFixed(2);
  }
  function escapeHtml(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]; }); }
  function escapeAttr(s) { return escapeHtml(s).replace(/'/g, '&#39;'); }
  function safePath(url) { return (typeof url === 'string' && url.charAt(0) === '/') ? url : '#'; }
  function sizeImg(src, w) { return (typeof src === 'string') ? src.replace(/(\.[a-zA-Z]+)(\?|$)/, '_' + w + 'x$1$2') : ''; }

  function getCart() { return getJSON(root + 'cart.js'); }
  function chooseAnchor(cart) {
    if (!cart || !cart.items || !cart.items.length) return null;
    return cart.items.slice().sort(function (a, b) { return b.price - a.price; })[0];
  }

  function getRecs(productId) {
    var key = 'vdc-recs-' + productId + '-' + CONFIG.intent;
    try {
      var raw = sessionStorage.getItem(key);
      if (raw) {
        var c = JSON.parse(raw);
        if (c && c.t && (Date.now() - c.t) < CONFIG.cacheTTLms) return Promise.resolve(c.products || []);
      }
    } catch (e) {}
    var url = root + 'recommendations/products.json?product_id=' + productId + '&intent=' + CONFIG.intent + '&limit=' + CONFIG.fetchLimit;
    return getJSON(url).then(function (data) {
      var products = (data && data.products) || [];
      try { sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), products: products })); } catch (e) {}
      return products;
    });
  }

  function availableVariants(p) { return (p.variants || []).filter(function (v) { return v.available; }); }
  function firstAvailableVariant(p) { return availableVariants(p)[0] || null; }

  function filterRecs(products, cart) {
    var inCart = {};
    (cart.items || []).forEach(function (it) { inCart[it.product_id] = true; });
    return products.filter(function (p) {
      if (inCart[p.id]) return false;
      if (!p.available) return false;
      if (!firstAvailableVariant(p)) return false;
      if (CONFIG.excludeHandles.indexOf(p.handle) !== -1) return false;
      if (CONFIG.excludeTypes.indexOf(p.product_type) !== -1) return false;
      return true;
    }).slice(0, CONFIG.maxRecs);
  }

  function cardHTML(product) {
    var vars = availableVariants(product);
    var v = vars[0];
    var img = product.featured_image || (product.images && product.images[0]) || '';
    var picker = '';
    if (vars.length > 1) {
      picker = '<select class="vdc-rec__variant" aria-label="Choose size for ' + escapeAttr(product.title) + '">' +
        vars.map(function (vv) { return '<option value="' + escapeAttr(vv.id) + '" data-price="' + escapeAttr(vv.price) + '">' + escapeHtml(vv.title) + '</option>'; }).join('') +
        '</select>';
    }
    return '' +
      '<div class="vdc-rec" data-product="' + escapeAttr(product.id) + '">' +
      '  <a class="vdc-rec__media" href="' + escapeAttr(safePath(product.url)) + '" tabindex="-1" aria-hidden="true">' +
      (img ? '<img loading="lazy" src="' + escapeAttr(sizeImg(img, 240)) + '" alt="" width="96" height="120">' : '') +
      '  </a>' +
      '  <div class="vdc-rec__info">' +
      '    <a class="vdc-rec__title" href="' + escapeAttr(safePath(product.url)) + '">' + escapeHtml(product.title) + '</a>' +
      '    <span class="vdc-rec__price">' + formatMoney((v && v.price) != null ? v.price : product.price) + '</span>' +
      '    <div class="vdc-rec__stars" data-handle="' + escapeAttr(product.handle) + '"></div>' +
      '    ' + picker +
      '  </div>' +
      '  <button type="button" class="vdc-rec__add" data-variant="' + escapeAttr(v ? v.id : '') + '">Add</button>' +
      '</div>';
  }

  function loadStars(mount) {
    var slots = mount.querySelectorAll('.vdc-rec__stars[data-handle]');
    Array.prototype.forEach.call(slots, function (slot) {
      var handle = slot.getAttribute('data-handle');
      if (!handle) return;
      var ck = 'vdc-stars-' + handle;
      try { var cached = sessionStorage.getItem(ck); if (cached != null) { slot.innerHTML = cached; return; } } catch (e) {}
      fetch(root + 'products/' + encodeURIComponent(handle) + '?section_id=' + CONFIG.starsSection)
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          html = (html || '').trim();
          slot.innerHTML = html;
          try { sessionStorage.setItem(ck, html); } catch (e) {}
        }).catch(function () {});
    });
  }

  function addToCart(variantId, btn) {
    if (!variantId || inFlightAdds[variantId]) return;
    inFlightAdds[variantId] = true;
    btn.disabled = true;
    var prev = btn.textContent;
    btn.textContent = 'Adding...';

    var sections = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sections } }));
    sections = sections.filter(function (s, i) { return sections.indexOf(s) === i; });

    getJSON(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }], sections: sections.join(','), sections_url: window.location.pathname })
    }).then(function (addResp) {
      return getCart().then(function (cart) {
        cart.sections = addResp.sections;
        var items = addResp.items || [addResp];
        document.documentElement.dispatchEvent(new CustomEvent('variant:add', { bubbles: true, detail: { items: items, cart: cart } }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart: cart } }));
        btn.textContent = 'Added';
      });
    }).catch(function (e) {
      btn.disabled = false;
      btn.textContent = (e && e.body && /sold out|unavailable|stock/i.test(e.body.description || '')) ? 'Sold out' : 'Try again';
      setTimeout(function () { if (btn && btn.isConnected) { btn.textContent = prev; } }, 2500);
      render();
    }).then(function () { delete inFlightAdds[variantId]; });
  }

  function render() {
    var mount = document.querySelector(CONFIG.container);
    if (!mount) return;
    if (mount.dataset.vdcFilled === '1') return;
    var myId = ++renderSeq;

    getCart().then(function (cart) {
      if (myId !== renderSeq) return;
      var anchor = chooseAnchor(cart);
      if (!anchor) { mount.innerHTML = ''; return; }
      return getRecs(anchor.product_id).then(function (products) {
        if (myId !== renderSeq) return;
        var recs = filterRecs(products, cart);
        if (!recs.length) { mount.innerHTML = ''; return; }
        mount.innerHTML = '<h3 class="vdc-recs__heading">You may also like</h3>' +
          '<div class="vdc-recs__list">' + recs.map(cardHTML).join('') + '</div>';
        mount.dataset.vdcFilled = '1';
        loadStars(mount);
      });
    }).catch(function (e) { if (window.console) console.warn('[vdc-cart-recs]', e); });
  }

  function onClick(e) {
    var btn = e.target.closest && e.target.closest('.vdc-rec__add');
    if (!btn) return;
    var card = btn.closest('.vdc-rec');
    var sel = card && card.querySelector('.vdc-rec__variant');
    var variantId = sel ? sel.value : btn.getAttribute('data-variant');
    addToCart(variantId, btn);
  }
  function onChange(e) {
    var sel = e.target.closest && e.target.closest('.vdc-rec__variant');
    if (!sel) return;
    var card = sel.closest('.vdc-rec');
    var opt = sel.options[sel.selectedIndex];
    if (card && opt) {
      var priceEl = card.querySelector('.vdc-rec__price');
      var addBtn = card.querySelector('.vdc-rec__add');
      if (priceEl && opt.dataset.price != null) priceEl.textContent = formatMoney(opt.dataset.price);
      if (addBtn) addBtn.setAttribute('data-variant', sel.value);
    }
  }

  var debounceT = null;
  function scheduleRender() { clearTimeout(debounceT); debounceT = setTimeout(render, 60); }

  function init() {
    document.addEventListener('click', onClick);
    document.addEventListener('change', onChange);
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof MutationObserver !== 'undefined') {
      new MutationObserver(function () {
        var mount = drawer.querySelector(CONFIG.container);
        if (mount && mount.dataset.vdcFilled !== '1') scheduleRender();
      }).observe(drawer, { childList: true, subtree: true });
    }
    ['cart:change', 'cart:refresh'].forEach(function (n) { document.addEventListener(n, scheduleRender); });
    scheduleRender();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
